import { countryService } from '../services/components/country_service.jsx'

function getListState(countryState) {
    return {
        type: "COUNTRY_STATE",
        countryState
    }
}

export const countryAction = () => dispatch => {
    let state = [];
    countryService((data => {
        (data) ? state = data : state = null 

        dispatch(getListState(state))
    }))
}


// WEBPACK FOOTER //
// ./src/actions/getcountryaction.jsx